<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card" v-bind:class="[selectDisable ? '' : 'disabled']">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">{{ action }} Data</h1>
      </header>
      <section
        class="modal-card-body scrollable-modal-body"
        v-if="form && columns && columns.length"
      >
        <div
          v-for="column in suppressColumn
            ? columns.filter(col => col.mapping)
            : columns"
          :key="column.field"
          class="no-margin-bottom"
        >
          <b-field :name="column.field">
            <template v-slot:label>
              <span v-html="column.label"></span>
            </template>
            <b-input
              v-model="form[String(column.field)]"
              maxlength="30"
              v-if="column.type == 'input'"
              :disabled="disable || column.editableCheck"
            >
            </b-input>
            <b-input
              v-model="form[String(column.field)]"
              maxlength="30"
              v-if="column.type == 'numberRange'"
              type="number"
              :disabled="disable || column.editableCheck"
            >
            </b-input>
            <b-datepicker
              v-if="column.type == 'dateField'"
              :name="column.field"
              v-model="form[`${column.field}`]"
              placeholder="Select date range"
              icon="calendar-today"
              trap-focus
              class="cdf-edit-add-padding cdf-edit-date-picker"
              :disabled="disable || column.editableCheck"
              required
            ></b-datepicker>

            <div v-if="column.type == 'multiSelectFilter'">
              <b-select
                class="cdf-edit-add-padding cdf-edit-select"
                v-model="form[`${column.field}`]"
                v-if="column.field == 'product_group'"
                @input="checkDependancy($event, column.field)"
              >
                <option
                  v-for="(value, index) in productGroup"
                  :value="value"
                  :key="index"
                  :title="value.name"
                >
                  {{ value.name }}
                </option>
              </b-select>
              <b-select
                v-else-if="column.field == 'product_family'"
                class="cdf-edit-add-padding cdf-edit-select"
                :disabled="
                  disable ||
                    (column.editableCheck && form[String(column.field)]['name'])
                "
                v-model="form[`${column.field}`]"
                @input="checkDependancy($event, column.field)"
              >
                <option
                  v-for="(value, index) in productFamily"
                  :value="value"
                  :key="index"
                  :title="value.name"
                >
                  {{ value.name }}
                </option>
              </b-select>
              <b-select
                v-else-if="column.field == 'material_detail'"
                class="cdf-edit-add-padding cdf-edit-select"
                :disabled="
                  disable ||
                    (column.editableCheck && form[String(column.field)]['name'])
                "
                v-model="form[`${column.field}`]"
                @input="checkDependancy($event, column.field)"
              >
                <option
                  v-for="(value, index) in materialDetail"
                  :value="value"
                  :key="index"
                  :title="value.name"
                >
                  {{ value.name }}
                </option>
              </b-select>
              <b-select
                v-else-if="column.field == 'material_general'"
                class="cdf-edit-add-padding cdf-edit-select"
                :disabled="
                  disable ||
                    (column.editableCheck && form[String(column.field)]['name'])
                "
                v-model="form[`${column.field}`]"
                @input="checkDependancy($event, column.field)"
              >
                <option
                  v-for="(value, index) in materialGeneral"
                  :value="value"
                  :key="index"
                  :title="value.name"
                >
                  {{ value.name }}
                </option>
              </b-select>
              <b-select
                v-else-if="column.field == 'chemistry'"
                class="cdf-edit-add-padding cdf-edit-select"
                :disabled="
                  disable ||
                    (column.editableCheck && form[String(column.field)]['name'])
                "
                v-model="form[`${column.field}`]"
                @input="checkDependancy($event, column.field)"
              >
                <option
                  v-for="(value, index) in chemistry"
                  :value="value"
                  :key="index"
                  :title="value.name"
                >
                  {{ value.name }}
                </option>
              </b-select>
              <b-select
                v-else-if="column.field == 'packaging_type'"
                class="cdf-edit-add-padding cdf-edit-select"
                :disabled="
                  disable ||
                    (column.editableCheck && form[String(column.field)]['name'])
                "
                v-model="form[`${column.field}`]"
                @input="checkDependancy($event, column.field)"
              >
                <option
                  v-for="(value, index) in packagingType"
                  :value="value"
                  :key="index"
                  :title="value.name"
                >
                  {{ value.name }}
                </option>
              </b-select>
              <b-select
                v-else-if="column.field == 'packaging_level'"
                class="cdf-edit-add-padding cdf-edit-select"
                :disabled="
                  disable ||
                    (column.editableCheck && form[String(column.field)]['name'])
                "
                v-model="form[`${column.field}`]"
                @input="checkDependancy($event, column.field)"
              >
                <option
                  v-for="(value, index) in packagingLevel"
                  :value="value"
                  :key="index"
                  :title="value.name"
                >
                  {{ value.name }}
                </option>
              </b-select>
              <b-select
                v-else
                class="cdf-edit-add-padding cdf-edit-select"
                :disabled="disable || column.editableCheck"
                v-model="form[`${column.field}`]"
                @input="checkDependancy($event, column.field)"
              >
                <option
                  v-for="(value, index) in column.allStatusVals.filter(
                    item => item.name != 'NA'
                  )"
                  :value="value"
                  :key="index"
                  :title="value.name"
                >
                  {{ value.name }}
                </option>
              </b-select>
            </div>
          </b-field>
        </div>
      </section>
      <footer class="modal-card-foot" v-if="!disable">
        <b-button slot="right" type="is-primary" @click="saveData">
          Save
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Cancel
        </b-button>
      </footer>
      <footer class="modal-card-foot" v-if="disable">
        <b-button
          v-if="disable && this.action !== 'View'"
          slot="right"
          type="is-danger"
          @click="removeReport"
        >
          Delete
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
// @group Customers
export default {
  name: "SingleProductEdit",
  props: {
    action: {
      type: String,
      default: ""
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    editObjectName: {
      type: Object
    },

    customerId: {
      type: Number,
      default: -1
    },

    columns: {
      type: Array
    },

    allProductFamily: {
      type: Object
    },

    allMaterialDetail: {
      type: Object
    },
    columnsConfig: {
      type: Array
    },
    suppressColumnView: {
      type: Boolean,
      default: false
    },
    materialGeneralDropdown: {
      type: Array,
      default: () => []
    },
    chemistryDropDown: {
      type: Array,
      default: () => []
    },
    packagingTypeDropDown: {
      type: Array,
      default: () => []
    },
    packagingLevelDropDown: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      customerDataService: new CustomerProfileDataService(),
      isModalActive: false,
      selectDisable: true,
      form: {},
      editData: [],
      productGroup: [],
      productFamily: [],
      materialDetail: [],
      materialGeneral: [],
      packagingType: [],
      packagingLevel: [],
      chemistry: [],
      suppressColumn: false
    };
  },
  mounted() {
    this.disableSelectProperty();
    this.processFormData();
  },
  computed: {
    disable() {
      if (this.action == "Edit") {
        return false;
      } else if (this.action == "View") {
        return true;
      } else if (this.action == "Delete") {
        return true;
      }
      return false;
    }
  },
  methods: {
    // function to convert to date format for datepicker input
    convertToDate(dt) {
      let newDate = null;
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    },
    processFormData() {
      if (this.columns && this.columns.length > 0) {
        // prepare the data as required form and create 'form' object with that
        this.columns.forEach(element => {
          if (element.type == "dateField") {
            //convert to date
            this.form[`${element.field}`] = this.editObjectName[
              `${element.field}`
            ]
              ? this.convertToDate(this.editObjectName[`${element.field}`])
              : null;
          } else if (element.type == "multiSelectFilter") {
            this.form[`${element.field}`] = {
              name: this.editObjectName[`${element.field}`]
            };

            if (this.columnsConfig && element.field == "product_group") {
              this.processProductGroup();
            }
            if (this.columnsConfig && element.field == "product_family") {
              this.processProductFamily();
            }
            if (this.columnsConfig && element.field == "material_detail") {
              this.processMaterialDetail();
            }
            if (this.columnsConfig && element.field == "material_general") {
              this.processMaterialGeneral();
            }
            if (this.columnsConfig && element.field == "chemistry") {
              this.processChemistry();
            }
            if (this.columnsConfig && element.field == "packaging_type") {
              this.processPackagingType();
            }
            if (this.columnsConfig && element.field == "packaging_level") {
              this.processPackagingLevel();
            }
          } else {
            this.form[`${element.field}`] = this.editObjectName[
              `${element.field}`
            ];
          }
        });
        return true;
      } else {
        return false;
      }
    },

    // Add methods for each dropdown to keep code organized
    processProductGroup() {
      const index = this.find_column_config_index("product_group");
      if (index >= 0) {
        const subCategoryList = this.columnsConfig[index][
          "dropdown_field_values"
        ];
        this.productGroup = this.prepareDropDownArray(subCategoryList) || [];
        this.productGroup = this.productGroup.filter(
          item => item && item.name && item.name != "NA"
        );
      }
    },

    processProductFamily() {
      if (this.form["product_group"] && this.form["product_group"].name) {
        const index = this.find_column_config_index("product_family");
        if (index >= 0) {
          const subCategoryList = this.columnsConfig[index][
            "dropdown_field_values"
          ];
          if (
            subCategoryList &&
            subCategoryList[0] &&
            subCategoryList[0][this.form["product_group"].name]
          ) {
            this.productFamily =
              this.prepareDropDownArray(
                subCategoryList[0][this.form["product_group"].name]
              ) || [];

            this.productFamily = this.productFamily.filter(
              item => item && item.name && item.name != "NA"
            );
          } else {
            this.productFamily = [];
          }
        }
      }
    },

    // Similar methods for other dropdowns
    processMaterialGeneral() {
      // Use new prop values first, fall back to old columnsConfig if needed
      if (
        this.materialGeneralDropdown &&
        this.materialGeneralDropdown.length > 0
      ) {
        this.materialGeneral = this.materialGeneralDropdown;
      } else {
        const index = this.find_column_config_index("material_general");
        if (index >= 0) {
          const subCategoryList = this.columnsConfig[index][
            "dropdown_field_values"
          ];
          this.materialGeneral =
            this.prepareDropDownArray(subCategoryList) || [];
          this.materialGeneral = this.materialGeneral.filter(
            item => item && item.name && item.name != "NA"
          );
        }
      }
    },

    processMaterialDetail() {
      if (this.form["material_general"] && this.form["material_general"].name) {
        const index = this.find_column_config_index("material_detail");
        if (index >= 0) {
          const subCategoryList = this.columnsConfig[index][
            "dropdown_field_values"
          ];
          if (
            subCategoryList &&
            subCategoryList[0] &&
            subCategoryList[0][this.form["material_general"].name]
          ) {
            this.materialDetail =
              this.prepareDropDownArray(
                subCategoryList[0][this.form["material_general"].name]
              ) || [];

            this.materialDetail = this.materialDetail.filter(
              item => item && item.name && item.name != "NA"
            );
          } else {
            this.materialDetail = [];
          }
        }
      }
    },
    processPackagingType() {
      // Use new prop values first, fall back to old columnsConfig if needed
      if (this.packagingTypeDropDown && this.packagingTypeDropDown.length > 0) {
        this.packagingType = this.packagingTypeDropDown;
      } else {
        const index = this.find_column_config_index("packaging_type");
        if (index >= 0) {
          const subCategoryList = this.columnsConfig[index][
            "dropdown_field_values"
          ];
          this.packagingType = this.prepareDropDownArray(subCategoryList) || [];
          this.packagingType = this.packagingType.filter(
            item => item && item.name && item.name != "NA"
          );
        }
      }
    },

    processPackagingLevel() {
      // Use new prop values first, fall back to old columnsConfig if needed
      if (
        this.packagingLevelDropDown &&
        this.packagingLevelDropDown.length > 0
      ) {
        this.packagingLevel = this.packagingLevelDropDown;
      } else {
        const index = this.find_column_config_index("packaging_level");
        if (index >= 0) {
          const subCategoryList = this.columnsConfig[index][
            "dropdown_field_values"
          ];
          this.packagingLevel =
            this.prepareDropDownArray(subCategoryList) || [];
          this.packagingLevel = this.packagingLevel.filter(
            item => item && item.name && item.name != "NA"
          );
        }
      }
    },

    processChemistry() {
      // Use new prop values first, fall back to old columnsConfig if needed
      if (this.chemistryDropDown && this.chemistryDropDown.length > 0) {
        this.chemistry = this.chemistryDropDown;
      } else {
        const index = this.find_column_config_index("chemistry");
        if (index >= 0) {
          const subCategoryList = this.columnsConfig[index][
            "dropdown_field_values"
          ];
          this.chemistry = this.prepareDropDownArray(subCategoryList) || [];
          this.chemistry = this.chemistry.filter(
            item => item && item.name && item.name != "NA"
          );
        }
      }
    },
    // return the index of the searched column
    find_column_index(column_name) {
      return this.columns.findIndex(col => col.field === column_name);
    },
    // populate the dependent columns for single edit/view
    checkDependancy(item, field) {
      if (field == "product_group") {
        const subCategoryList = this.columnsConfig[
          this.find_column_config_index("product_family")
        ]["dropdown_field_values"];
        this.productFamily = [];
        // Add null check here
        if (
          subCategoryList &&
          subCategoryList[0] &&
          subCategoryList[0][item.name]
        ) {
          this.productFamily = [
            ...this.prepareDropDownArray(subCategoryList[0][item.name])
          ];
        } else {
          console.warn("No product families found for:", item.name);
        }
      }
      if (field == "material_general") {
        this.materialDetail = [];
        const subCategoryList = this.columnsConfig[
          this.find_column_config_index("material_detail")
        ]["dropdown_field_values"];
        this.materialDetail = [
          ...this.prepareDropDownArray(subCategoryList[0][item.name])
        ];
      }
    },
    disableSelectProperty() {
      if (this.isAction == "Edit" || this.action == "Delete") {
        this.selectDisable = false;
      }
    },
    cancel() {
      this.form = {};
      this.$emit("cancel");
    },
    find_column_config_index(column_name) {
      return this.columnsConfig.findIndex(
        col => col.product_data_column.trim() === column_name.trim()
      );
    },
    prepareDropDownArray(value) {
      const result = [];
      if (value && Array.isArray(value)) {
        value.forEach(element => {
          const obj = {};
          obj["name"] = element;
          result.push(obj);
        });
      }
      return result;
    },
    saveData() {
      //before passing the object add id
      this.form.id = this.editObjectName?.id;
      for (const key in this.form) {
        if (
          typeof this.form[key] === "object" &&
          this.form[key] != null &&
          key != "valid_to" &&
          key != "valid_from"
        ) {
          this.form[key] = this.form[key].name;
        }

        if (this.form[key] === "") {
          this.form[key] = null;
        }
      }
      // remove the actions data from the object
      delete this.form.actions;
      this.$emit("updateSingleData", this.form);
    }
  },

  watch: {
    suppressColumnView(newValue) {
      this.suppressColumn = newValue;
    },
    isActive(newValue) {
      this.isModalActive = newValue;
      if (newValue) {
        // Process form data when modal becomes active
        this.processFormData();
      }
    },

    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    },

    // Add these watchers for dependent dropdowns
    "form.product_group": {
      handler(newVal) {
        if (newVal && newVal.name) {
          // Force update product family dropdown when product group changes
          this.processProductFamily();
        }
      },
      deep: true
    },

    "form.material_general": {
      handler(newVal) {
        if (newVal && newVal.name) {
          // Force update material detail dropdown when material general changes
          this.processMaterialDetail();
        }
      },
      deep: true
    },

    // Watch for changes to columns array
    columns: {
      handler() {
        this.processFormData();
      },
      deep: true
    },

    // Watch for changes to editObjectName
    editObjectName: {
      handler() {
        this.processFormData();
      },
      deep: true
    },

    // Watch for changes to columnsConfig
    columnsConfig: {
      handler() {
        this.processFormData();
      },
      deep: true
    },

    // Watch for changes to dropdown props
    materialGeneralDropdown(newValue) {
      if (newValue && Array.isArray(newValue)) {
        this.materialGeneral = newValue;
      }
    },

    chemistryDropDown(newValue) {
      if (newValue && Array.isArray(newValue)) {
        this.chemistry = newValue;
      }
    },

    packagingTypeDropDown(newValue) {
      if (newValue && Array.isArray(newValue)) {
        this.packagingType = newValue;
      }
    },

    packagingLevelDropDown(newValue) {
      if (newValue && Array.isArray(newValue)) {
        this.packagingLevel = newValue;
      }
    }
  }
};
</script>
<style scoped>
.scrollable-modal-body {
  max-height: 60vh;
  overflow-y: auto !important;
  overflow-x: hidden;
}
</style>
